export const FLAG_GETTING_BAGGAGE_ITEMS = 'FLAG_GETTING_BAGGAGE_ITEMS';
export const GET_BAGGAGE_ITEMS = 'GET_BAGGAGE_ITEMS';
export const CLEAR_BAGGAGE_ITEMS = 'CLEAR_BAGGAGE_ITEMS';

export const GET_BAGGAGE_ITEM = 'GET_BAGGAGE_ITEM';
export const FLAG_ITEM_ACTIVITY = 'FLAG_ITEM_ACTIVITY';
export const CLEAR_BAGGAGE_ITEM = 'CLEAR_BAGGAGE_ITEM';
